<template>
	<div>
		<van-nav-bar :title="$t('VIP')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="id">
			<div class="head">
				<van-image class="head_img" :src="url" v-if="userInfo.level_steps!=config.levelList.length-1" />
				<van-image class="head_img" :src="urla" v-else />
				<div class="head_text">NO:{{userInfo.vip_number}}</div>
			</div>
			<div class="custom-steps">
				<div class="steps-wrapper">
					<div v-for="(item, index) in config.levelList" :key="index" class="step-item"
						:class="{ 'is-active': index <= userInfo.level_steps,'is-current': index === userInfo.level_steps }">
						<div class="step-line" v-if="index !== 0"></div>
						<div class="step-node">
							<span v-if="index <= userInfo.level_steps" class="iconfont">✔</span>
							<span v-else>{{ index + 1 }}</span>
						</div>
						<div class="step-title">{{ item.name }}</div>
					</div>
				</div>
			</div>
			<div v-html="config.vipContent"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				url: require('../../img/vip_head.png'),
				urla: require('../../img/vip_head1.png'),
				config: {
					levelList:[]
				},
				userInfo: {
					vip_number: ''
				}
			};
		},
		created() {
			this.getBaseInfo();
			this.getUserInfo()
		},
		methods: {
			back() {
				return window.history.back();
			},
			getBaseInfo() {
				this.$http({
					method: 'get',
					url: 'base_info'
				}).then(res => {
					this.config = res.data
				})
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 1) {
						this.userInfo = res.data;
					} else {
						this.$toast(res.msg);
					}
				})
			},
		},
	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.custom-steps {
		background-color: #fff;
		width: 100%;
		box-sizing: border-box;
		display: flex;
		padding: 20px 0;

		.steps-wrapper {
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			position: relative;
		}

		.step-item {
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			position: relative;

			.step-line {
				position: absolute;
				height: 2px;
				background-color: #ebedf0;
				top: 30px;
				left: -50%;
				right: 50%;
				z-index: 1;
			}

			.step-node {
				width: 50px;
				height: 50px;
				border-radius: 50%;
				border: 2px solid #ebedf0;
				background-color: #fff;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 28px;
				color: #969799;
				position: relative;
				z-index: 2;
				transition: all 0.3s;
			}

			.iconfont {
				margin-bottom: 4px;
			}

			.step-title {
				margin-top: 20px;
				font-size: 24px;
				color: #969799;
				text-align: center;
				line-height: 1.2;
				word-break: break-word;
				padding: 0 5px;
			}

			&.is-active {
				.step-node {
					background-color: #d63f8c;
					border-color: #d63f8c;
					color: #fff;
				}

				.step-line {
					background-color: #d63f8c;
				}

				.step-title {
					color: #d63f8c;
				}
			}

			&.is-current {
				.step-node {
					box-shadow: 0 0 10px rgba(214, 63, 140, 0.4);
				}
			}
		}
	}

	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	.id {
		padding: 20px;
	}

	.head {
		position: relative;

		.head_img {
			width: 100%;
		}

		.head_text {
			position: absolute;
			bottom: 14px;
			left: 20px;
			color: #e2d073;
		}
	}

	.van-cell {
		font-size: 35px;
		line-height: 80px;
	}
</style>